import { render, staticRenderFns } from "./RecordingForm.vue?vue&type=template&id=480dd8e4"
import script from "./RecordingForm.vue?vue&type=script&lang=js"
export * from "./RecordingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports